import {ChainId, Mainnet, Goerli} from '@usedapp/core';

const stage = process.env.REACT_APP_ENV;

console.log(`Network: ${stage === 'staging' ? 'GOERLI' : 'MAINNET'}`);

var readUrlsDict = {};
if(stage === 'staging'){
    readUrlsDict[ChainId.Goerli] = `https://goerli.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`;
}else{
    readUrlsDict[ChainId.Mainnet] = `https://mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`;
}

const DappConfig = {
    readOnlyChainId: stage === 'staging' ? ChainId.Goerli : ChainId.Mainnet,
    readOnlyUrls: readUrlsDict,
    pollingInterval: 1000,
    networks: [stage === 'staging' ? Goerli : Mainnet],
    notifications: {
      checkInterval: 100,
      expirationPeriod: 10000,
    },
    autoConnect: true
}

export default DappConfig;